angular.module('common.directives.urlencode', [])

    .filter('urlencode', function () {
        return function (input) {
            if (input) {
                return window.encodeURIComponent(input);
            }
            return "";
        };
    })

;